"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyTypes = exports.WayOfPaying = void 0;
/** not source of truth (yet) */
var WayOfPaying;
(function (WayOfPaying) {
    WayOfPaying["CreditCard"] = "CREDIT_CARD";
    WayOfPaying["Free"] = "FREE";
    WayOfPaying["Invoice"] = "INVOICE";
})(WayOfPaying = exports.WayOfPaying || (exports.WayOfPaying = {}));
/** not source of truth (yet) */
var CompanyTypes;
(function (CompanyTypes) {
    CompanyTypes["Boats"] = "BOATS";
    CompanyTypes["Cleaning"] = "CLEANING";
    CompanyTypes["It"] = "IT";
})(CompanyTypes = exports.CompanyTypes || (exports.CompanyTypes = {}));
